import NextHead from 'next/head'
import Script from 'next/script'
import config from '../../../config.json'
import { useDataProvider } from '../../hooks/dataProvider'

export default function Head({ trackUrl }) {
    const { data } = useDataProvider()

    if (typeof window !== 'undefined') {
        if (config?.integrations?.sanjagh?.push?.token)
            window.snj_notif = {
                publisher_id: config.integrations.sanjagh.push.token,
                delay: 5,
            }
    }
    return (
        <>
            <NextHead>
                <link
                    rel="shortcut icon"
                    type="image/x-icon"
                    href="/img/favicon/favicon.ico"
                />
                <link
                    rel="icon"
                    type="image/png"
                    sizes="32x32"
                    href="/img/favicon/favicon-32x32.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="/img/favicon/apple-touch-icon.png"
                />
            </NextHead>
            {config.integrations?.umami && trackUrl && (
                <Script
                    id="umami-tracker"
                    async
                    defer
                    data-auto-track="false"
                    data-website-id={config.integrations.umami.websiteId}
                    src={`${config.integrations.umami.endpoint}/script.js`}
                    onLoad={() => {
                        /* global umami */
                        umami.track((props) => ({
                            ...props,
                            url: trackUrl,
                        }))
                    }}
                />
            )}
            {config.integrations?.truepush && (
                <Script
                    type="application/javascript"
                    src={config.integrations.truepush.sdk}
                    async
                />
            )}
            {config.integrations?.promizer && data?.buildTime && (
                <>
                    <Script
                        id="promizer-loader"
                        type="application/javascript"
                        src={`https://cdn-my.promizer.com/api/public/_/${data.buildTime.split('T')[0].replace(/-/g, '')}/sdk/script.js`}
                        async
                    />
                    <Script
                        id="promizer-config"
                        dangerouslySetInnerHTML={{
                            __html: `window.promizer = window.promizer || {
                                push: "${config.integrations.promizer.push}",
                                config: ${JSON.stringify(config.integrations.promizer.config)}
                              };`,
                        }}
                    />
                </>
            )}
            {config.integrations?.truepush && (
                <Script
                    id="truepush"
                    dangerouslySetInnerHTML={{
                        __html: `var truepush = window.truepush || []; truepush.push(function()
                {truepush.Init(
                    {
                        id: '${config.integrations.truepush.token}'
                    },
                    function (error) {
                        if (error) console.error(error)
                    }
                )}
                )`,
                    }}
                />
            )}
            {config.integrations?.sanjagh?.push && data?.buildTime && (
                <>
                    {/* <Script
                        type="application/javascript"
                        src="https://api.sanjagh.com/assets/notif-sdk/firebase-messaging-sw.js"
                        async
                    /> */}
                    <Script
                        type="application/javascript"
                        src={`https://cdn.sanjagh.com/assets/sdk/notif.js?t=${data.buildTime}`}
                        async={false}
                    />
                </>
            )}
            {config.integrations?.ua && (
                <Script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${config.integrations.ua.id}`}
                />
            )}
            {config.integrations?.ua && (
                <Script
                    id="googleTag"
                    dangerouslySetInnerHTML={{
                        __html: `window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());
                            gtag('config', '${config.integrations.ua.id}');`,
                    }}
                />
            )}
            {config.integrations?.ga && (
                <Script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${config.integrations.ga.id}`}
                />
            )}
            {config.integrations?.ga && (
                <Script
                    id="googleTagOld"
                    dangerouslySetInnerHTML={{
                        __html: ` window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());
                            gtag('config', '${config.integrations.ga.id}');`,
                    }}
                />
            )}
        </>
    )
}
